<template>
  <div>

    <div v-for="(sval, skey) in sessions" :key="skey">

      <div :style="{ 
        color: sval.session_type ? sval.session_type.value.color : '#000000', 
        background: sval.session_type ? sval.session_type.value.background : '#eeeeee'
      }">

        <table class="details session head" :class="{ divider: skey > 0 }">
          <tr>
            <td colspan="3" v-if="sval.day && (sval.start_time && sval.end_time) && sval.room">
              <span v-if="sval.day">{{ formatDate(sval.day) }}</span>
              <span v-if="sval.start_time && sval.end_time"><br>{{ sval.start_time }} &ndash; {{ sval.end_time }}</span>
              <span v-if="sval.virtual_room" style="float: right">{{ sval.virtual_room['name_' + language] }}</span>
              <span v-else-if="sval.room" style="float: right">{{ sval.room['name_' + language] }}</span>
            </td>
          </tr>
          <tr v-if="sval.session_type">
            <td colspan="3"> 
              <span v-if="sval.session_group">{{ _[sval.session_group.name] }}<br></span>
              {{ _[sval.session_type.name] }}
            </td>
          </tr>
          <tr>
            <td colspan="3"> 
              <router-link :to="'/session/' + sval.id + '/edit'">
                <b style="font-size: 16px; line-height: 19px;">
                  <img
                    v-if="sval.live_translation_link"
                    src="@/assets/img/icon_uebersetzung.png"
                    alt="Live Übersetzung"
                    style="height: 18px; width: auto; vertical-align: middle; margin-right: 6px;"
                  >
                  <span v-if="sval.code">{{ sval.code }}&nbsp;</span>
                  <span v-html="sval.title"></span>
                </b>
              </router-link>
            </td>
          </tr>
          <tr v-if="sval.content && sval.content.outline">
            <td colspan="3" v-html="sval.content.outline"></td>
          </tr>
        </table>

        <table class="details session persons" v-if="sval.persons.length > 0">
          <tr>
            <td colspan="3">
              <template v-for="(pval, pkey) in sval.persons">
                <router-link :key="'sperson' + pkey" :to="'/person/' + pval.person.id + '/edit'">
                  {{ pval.role.name }}: {{ pval.person.first_name }} {{ pval.person.last_name }}
                  <span v-if="pval.person.city || pval.person.country"> (</span>
                  <span v-if="pval.person.city">{{ pval.person.city }}</span>
                  <span v-if="pval.person.city && pval.person.country && pval.person.country.value.display">, </span>
                  <span v-if="pval.person.country && pval.person.country.value.display">{{ pval.person.country.value.kfz }}</span>
                  <span v-if="pval.person.city || pval.person.country">)</span>
                  <span class="icon" :class="pval.participation.state.name"><font-awesome-icon :icon="['fas', 'envelope']" /></span>
                </router-link>
                <span
                  :key="'sconflicts' + pkey"
                  class="icon"
                  v-if="pval.person.overlapping"
                  @click.stop="showConflicts({ model: 'session', type: 'session_person_overlappings', id: sval.id })">
                  <font-awesome-icon :icon="['fad', 'user-friends']" />
                </span>
                <span
                  :key="'sconflicts' + pkey"
                  class="icon"
                  v-if="pval.person.cleared_overlapping"
                  @click.stop="showConflicts({ model: 'session', type: 'session_person_overlappings', id: sval.id })">
                  <font-awesome-icon :icon="['fad', 'user-friends']" :style="{ color: '#007800' }" />
                </span>
                <br :key="'sbr' + pkey">
              </template>
            </td>
          </tr>
        </table>

      </div>

      <div class="presentations" v-if="sval.presentations.length > 0">

        <table class="details session presentations">
          <tr class="empty">
            <td class="code"></td>
            <td class="title"></td>
            <td class="time"></td>
          </tr>
          <tr v-for="(cval, ckey) in sval.presentations" :key="ckey" :class="{ backup: !cval.presentation.publish, headline: cval.presentation.display_type_id === 11 }">
            <td class="code" v-if="cval.presentation.display_type_id !== 11">
              <span v-if="cval.code && cval.display_type_id !== 11">{{ cval.code }}</span>
            </td>
            <td class="title" :colspan="colspan(cval.presentation.display_type_id)">
              <router-link :to="'/presentation/' + cval.presentation.id + '/edit'"><b v-html="cval.presentation.title"></b></router-link>
              <span class="abstract_details" v-if="cval.abstract_id" @click="showDetails({ model: 'presentation', id: cval.presentation.id })">{{ _.abstract }}</span>
              <div v-if="cval.presentation.persons">
                <template v-for="(pval, pkey) in cval.presentation.persons.filter(person => person.role.value['in_reports'] === true)">
                  <router-link :key="'pperson' + pkey" :to="'/person/' + pval.person.id + '/edit'">
                    {{ pval.role.name }}: {{ pval.person.first_name }} {{ pval.person.last_name }}
                    <span v-if="pval.person.city || pval.person.country"> (</span>
                    <span v-if="pval.person.city">{{ pval.person.city }}</span>
                    <span v-if="pval.person.city && pval.person.country && pval.person.country.value.display">, </span>
                    <span v-if="pval.person.country && pval.person.country.value.display">{{ pval.person.country.value.kfz }}</span>
                    <span v-if="pval.person.city || pval.person.country">)</span>
                    <span class="icon" :class="pval.participation.state.name"><font-awesome-icon :icon="['fas', 'envelope']" /></span>
                  </router-link>
                  <span
                    :key="'sconflicts' + pkey"
                    class="icon"
                    v-if="pval.person.overlapping"
                    @click.stop="showConflicts({ model: 'session', type: 'session_person_overlappings', id: sval.id })">
                    <font-awesome-icon :icon="['fad', 'user-friends']" />
                  </span>
                  <span
                    :key="'sconflicts' + pkey"
                    class="icon"
                    v-if="pval.person.cleared_overlapping"
                    @click.stop="showConflicts({ model: 'session', type: 'session_person_overlappings', id: sval.id })">
                    <font-awesome-icon :icon="['fad', 'user-friends']" :style="{ color: '#007800' }" />
                  </span>
                  <br :key="'pbr' + pkey">
                </template>
              </div>
            </td>
            <td class="time">
              <span v-if="cval.start_time && settings.presentation.show_empty_times && cval.presentation.display_type_id !== 11">
                {{ cval.start_time }} &ndash; {{ cval.end_time }}
                <br>{{ (cval.duration - cval.including) }} {{ _.minutes_abbreviation }}
                <span v-if="cval.including">+ {{ cval.including }} {{ _.minutes_abbreviation }} {{ _.discussion }}</span>
              </span>
            </td>
          </tr>
        </table>
      </div>

    </div>

  </div>
</template>

<script>
import { API_URL } from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['id'],
  data() {
    return {
      sessions: [],
    }
  },
  computed: {
    ...mapGetters(['settings', 'details']),
  },
  methods: {
    colspan(type) {
      return (type === 11) ? 2 : 1;
    },
    // getSessionPersonConflictStatus(session_id, person_id) {
    //   return this.overlappings.some(overlapping => overlapping.session_id === session_id && overlapping.person_id === person_id && overlapping.clarified === true);
    // },
    // getPresentationPersonConflictStatus(session_id, presentationId, person_id) {
    //   return this.overlappings.some(overlapping => overlapping.session_id === session_id && overlapping.presentation_id === presentationId && overlapping.person_id === person_id && overlapping.clarified === true);
    // },
  },
  async created() {
    const session = await this.axios.get(API_URL + '/sessions/' + this.id + '/details');
    let children = [];
    if ([9,376].includes(session.data[0].display_type_id)) {
      children = session.data[0].children.map(child => child.id);
    }
    if (children.length) {
      const sessions = await this.axios.get(API_URL + '/sessions/' + children.join(',') + '/details');
      this.sessions = sessions.data;
    } else {
      this.sessions = session.data;
    }
    this.sessions.forEach(session => {
      session.persons.forEach(session_person => {
        if (session_person.person.overlappings.length) {
          session_person.person.overlappings.forEach(overlapping => {
            if (overlapping.session_id === session.id) {
              session_person.person.overlapping = overlapping;
            }
          });
          session_person.person.cleared_overlappings.forEach(cleared_overlapping => {
            if (cleared_overlapping.session_id === session.id) {
              session_person.person.cleared_overlapping = cleared_overlapping;
            }
          });
        }
      });
      session.presentations.forEach(session_presentation => {
        if (session_presentation.presentation.persons) {
          session_presentation.presentation.persons.forEach(presentation_person => {
            if (presentation_person.person.overlappings.length) {
              presentation_person.person.overlappings.forEach(overlapping => {
                if (overlapping.session_id === session.id && overlapping.presentation_id === session_presentation.presentation.id) {
                  presentation_person.person.overlapping = overlapping;
                }
              });
              presentation_person.person.cleared_overlappings.forEach(cleared_overlapping => {
                if (cleared_overlapping.session_id === session.id && cleared_overlapping.presentation_id === session_presentation.presentation.id) {
                  presentation_person.person.cleared_overlapping = cleared_overlapping;
                }
              });
            }
          });
        }
      });
    });
    this.setProgress(false);
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.details {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  td {
    padding: 6px 12px;
    vertical-align: top;
    &.code { width: 80px; }
    &.title { width: 100%; }
    &.time { width: 260px; text-align: right; }
    a {
      color: inherit;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &.head.divider {
    border-top: 1px solid lighten($primary-color, 80%);
  }
  &.persons tr:first-child td {
    padding-top: 0px;
  }
  &:not(.persons) tr:first-child td {
    padding-top: 16px;
  }
  &.head:last-child td, &.persons:last-child td {
    padding-bottom: 16px;
  }
  &.presentations {
    > tr.empty > td {
      padding: 0;
    }
    > tr.backup > td {
      background: lighten($primary-color, 90%);
    }
    > tr:last-child td {
      padding-bottom: 16px;
    }
    > tr.headline > td {
      padding-top: 12px;
      padding-bottom: 12px;
      // border-top: 1px solid lighten($primary-color, 80%);
      border-bottom: 1px solid lighten($primary-color, 80%);
    }
  }
  .icon {
    display: inline-block;
    margin: 0 0 0 4px;
    font-size: 13px;
    cursor: pointer;
    &.not_invited {
      color: $primary-color;
      opacity: .3;
    }
    &.invited {
      color: $warning-color;
    }
    &.confirmed {
      color: $success-color;
    }
    &.declined {
      color: $error-color;
    }
    > svg {
      margin-bottom: -1px;
    }
  }
  .abstract_details {
    margin-left: 4px;
    padding: 1px 4px 1px 4px;
    background: #e4e4e4;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
    border-radius: 4px;
  }
}
</style>
